import DashboardLayout from "../../components/dashboard/DashboardLayout";
import BookOrderHistory from "../../components/dashboard/BookOrderHistory";

export default function BookOrderHistoryPage() {
  return (
    <DashboardLayout>
      <BookOrderHistory />
    </DashboardLayout>
  );
}
